import { useLocation } from "react-router";

const NavItem = ({ item }) => {
  const location = useLocation();

  return (
    <a
      className={`nav-item ${
        location.pathname.startsWith(item.link) ? "active" : ""
      }`}
      href={item.link}
    >
      <div className="title font-amaticsc-bold">{item.title}</div>
      <div className="sub-title font-amaticsc">{item.subTitle}</div>
    </a>
  );
};

export default NavItem;
